import { useEffect, useState } from "react";
import axios from "axios";
import AdCreative from "@/components/AdCreative";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdBanner({ zone, className = "" }) {
  const [ad, setAd] = useState(null);

  useEffect(() => {
    axios.get(`${API}/ads/active?zone=${zone}`).then(({ data }) => setAd(data || null)).catch(() => {});
  }, [zone]);

  if (!ad) return null;

  const click = () => {
    axios.post(`${API}/ads/${ad.id}/click`).catch(() => {});
    if (ad.link_url) window.open(ad.link_url.startsWith("http") ? ad.link_url : `https://${ad.link_url}`, "_blank", "noopener");
  };

  return (
    <div className={`relative w-full overflow-hidden border border-white/10 my-4 ${className}`} data-testid={`ad-banner-${zone}`} data-layout={ad.size}>
      <button onClick={click} className="block w-full cursor-pointer text-left" data-testid={`ad-click-${zone}`} title={ad.title}>
        <AdCreative ad={ad} />
      </button>
      <span className="absolute top-1 right-1 bg-black/70 text-zinc-400 text-[7px] font-black uppercase tracking-widest px-1.5 py-0.5 pointer-events-none">
        Sponsored
      </span>
    </div>
  );
}
